// Manual gift links — "stranded" recipient merge tags.
//
// Recipient-scoped tags resolve from a recipient list. A manual campaign has none — links are
// anonymous — so these render as empty strings on the unboxing page. Sender tags
// (@SenderFirstName / @SenderLastName / @SenderCompany / @Signature) still resolve from the
// campaign-level sender, so they are NOT flagged. The copy is never rewritten; switching gfg →
// manual just warns about what will render blank.

export const RECIPIENT_ONLY_TAGS = ["@FirstName", "@LastName"] as const;

/**
 * Which recipient-only tags appear (word-boundary matched, so "@FirstNameOfCompany" doesn't count
 * as "@FirstName") in any of the given landing-copy fields. Returns [] when clean.
 */
export function findStrandedRecipientTags(fields: Array<string | undefined | null>): string[] {
  const haystacks = fields.map((f) => f ?? "");
  return RECIPIENT_ONLY_TAGS.filter((tag) => {
    const re = new RegExp(`${tag}\\b`);
    return haystacks.some((h) => re.test(h));
  });
}
